export default __webpack_public_path__ + "static/media/Image_OB_Searching@3x.4bb0fac4.png";